import React, { useReducer } from 'react';
import { ContactContext } from './contactContext';
import contactReducer from './contactReducer';
import { DEFAULT_CONTACT_STATE } from './constants/defaultState';
import { clearState, setLoading } from '../utils';
import { IContactState } from './types';
import {
    createContact,
    getContact,
    searchContactsByFilters,
    updateContact,
    bulkDeleteContacts,
} from './utils';
import { clearContact } from './utils/clearContact';

export const ContactState = ({ children }: IContactState) => {
    const [state, dispatch] = useReducer(contactReducer, DEFAULT_CONTACT_STATE);

    return (
        <ContactContext.Provider
            value={{
                ...state,
                clearState: () =>
                    clearState(dispatch, {
                        contact: null,
                        contacts: null,
                        total: 0,
                        loading: false,
                        loadingContactList: false,
                        error: null,
                        success: null,
                    }),
                clearContact: () =>
                    clearContact(dispatch, {
                        ...state,
                        contact: null,
                    }),
                setLoading: () => setLoading(dispatch),
                createContact: (body) => createContact(dispatch, body),
                searchContactsByFilters: (filters, options) =>
                    searchContactsByFilters(dispatch, filters, options),
                getContact: (contactId) => getContact(dispatch, contactId),
                updateContact: (contactId, body) =>
                    updateContact(dispatch, contactId, body),
                bulkDeleteContacts: (values, callback) =>
                    bulkDeleteContacts(dispatch, values, callback),
            }}
        >
            {children}
        </ContactContext.Provider>
    );
};
